<template>
  <Modal @close="router.push('/')">
    <div class="sites-templates-modal">
      <h1>Коллекция шаблонов</h1>
      <div class="site-templates-list">
        <SiteTemplateItem
          v-for="template in templates"
          :key="template.id"
          :item="template"
        />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { Modal } from '@/shared/ui/modal';
import { useSiteTemplates } from '@/entities/site-template';
import SiteTemplateItem from '@/widgets/sites-templates/ui/SiteTemplateItem.vue';

const router = useRouter();

const { fetchTemplates } = useSiteTemplates();
const { templates } = storeToRefs(useSiteTemplates());

onMounted(async () => {
  await fetchTemplates();
});
</script>

<style lang="scss" scoped>
.sites-templates-modal {
  width: 1100px;
  height: auto;
  padding: 40px 90px 60px;
  background-color: white;

  h1 {
    font-family: 'OpenSans';
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    margin: 0 0 24px;
  }

  .site-templates-list {
    display: grid;
    grid-template-columns: 350px 350px 350px;
    column-gap: 25px;
    row-gap: 60px;
  }
}
</style>
